import { useState, useEffect } from "react";

type CountdownTimerProps = {
  timeLeft: number;
  setTimeLeft: React.Dispatch<React.SetStateAction<number>>;
  pauseSong: Function;
};

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeLeft, setTimeLeft, pauseSong }) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
        setTimeLeft((prev: number) => Math.max(prev - 1, 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, setTimeLeft]);

  const progress = (timeLeft / 20) * circumference;
  const color = `rgb(${(1 - timeLeft / 20) * 255}, ${timeLeft / 20 * 255}, 0)`; // Transition from green to red
  
  if (timeLeft == 0) {
    console.log("hier");
    pauseSong();
    return <div></div>
  }
  return (
    
    <div className="flex justify-center items-center h-screen">
      <svg width="120" height="120" viewBox="0 0 120 120">
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke="#ddd"
          strokeWidth="10"
        />
        <circle
          cx="60"
          cy="60" 
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
        <text x="50%" y="50%" textAnchor="middle" dy=".3em" fontSize="20" fill="#000">
        🎵
        </text>
      </svg>
    </div>
  );
};

export default CountdownTimer;
